
import { defineComponent, PropType, computed } from 'vue';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';

export interface INguoiKiemNghiem {
  thuTu: number;
  hoTen: string;
  chucVu: string;
  thanhPhan: string;
}

export default defineComponent({
  name: 'nguoi-kiem-nghiem',

  components: {
    ButtonCustom,
  },

  props: {
    modelValue: {
      type: Array as PropType<INguoiKiemNghiem[]>,
      default: () => [],
    },
    giamDocName: {
      type: String,
      default: '',
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    showGiamDocInput: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update:modelValue', 'update:giamDocName', 'change'],

  setup(props, { emit }) {
    const { ButtonsType, ButtonTypeColors } = useButtonCustom();

    // Use props directly to avoid circular updates
    const hoiDongKiemNghiem = computed(() => props.modelValue);

    // Computed property for giamDocName with getter/setter
    const localGiamDocName = computed({
      get: () => props.giamDocName,
      set: (value: string) => {
        emit('update:giamDocName', value);
      },
    });

    const updateField = (
      index: number,
      field: keyof INguoiKiemNghiem,
      value: string
    ) => {
      if (!props.isEditable) return;

      const newArray = [...props.modelValue];
      newArray[index] = { ...newArray[index], [field]: value };
      emit('update:modelValue', newArray);
    };

    const onDataChange = () => {
      emit('change', [...props.modelValue]);
    };

    const onAddNguoiKiemNghiem = () => {
      if (!props.isEditable) return;

      const newThuTu = props.modelValue.length + 1;
      const newItem = {
        thuTu: newThuTu,
        hoTen: '',
        chucVu: '',
        thanhPhan: '',
      };

      emit('update:modelValue', [...props.modelValue, newItem]);
    };

    const onDeleteNguoiKiemNghiem = () => {
      if (!props.isEditable || props.modelValue.length <= 1) return;

      const newArray = [...props.modelValue];
      newArray.pop();
      emit('update:modelValue', newArray);
    };

    return {
      ButtonsType,
      ButtonTypeColors,
      hoiDongKiemNghiem,
      localGiamDocName,
      updateField,
      onDataChange,
      onAddNguoiKiemNghiem,
      onDeleteNguoiKiemNghiem,
    };
  },
});
